import { Component, inject, input, type OnInit, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { type IncidentDto, type IncidentNote, IncidentNoteSource, IncidentNotesService } from '@api/incidents';
import { Store } from '@ngrx/store';
import { IncidentsActions } from '@ngrx-store';
import { NotificationsService } from '@ui';
import { map } from 'rxjs';

import { IncidentNoteComponent } from './incident-note.component';

@Component({
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatProgressSpinner, IncidentNoteComponent],
  selector: 'avs-incident-notes',
  styleUrl: './incident-notes.component.scss',
  templateUrl: './incident-notes.component.html',
})
export class IncidentNotesComponent implements OnInit {
  incident = input.required<IncidentDto>();
  noteAdded = output<IncidentNote>();
  protected postNoteLoading = signal(false);
  protected noteDescription = '';
  protected notes = signal<IncidentNote[]>([]);

  private notificationService = inject(NotificationsService);
  private incidentNotesService = inject(IncidentNotesService);
  private store = inject(Store);

  ngOnInit() {
    this.incidentNotesService
      .findAll({ incidentId: this.incident().id })
      .subscribe(response => {
        this.notes.set(response.data);
      });
  }

  protected addNote() {
    this.postNoteLoading.set(true);
    this.incidentNotesService
      .create(
        { incidentId: this.incident().id },
        {
          source: IncidentNoteSource.API,
          textValue: this.noteDescription,
        },
      )
      .pipe(map(response => response.data))
      .subscribe({
        complete: () => {
          this.postNoteLoading.set(false);
        },
        error: error => {
          this.notificationService.showErrorMessage(error.message);
        },
        next: note => {
          this.noteDescription = '';
          this.notes.update(notes => [note, ...notes]);
          this.store.dispatch(IncidentsActions.loadAllIncidents());
          this.noteAdded.emit(note);
        },
      });
  }
}
